export const PerformerConstants = {
    patient: 'patient',
    caregiver: 'caregiver'
};
// FIXME PerformerConstants should be migrated to PerformerType
export enum PerformerType {
	CAREGIVER = 'caregiver',
	PATIENT = 'patient',
}
